<button class="linklike" id="back">&larr; Retour</button>
<div class="albumHeader">
  <img class="albumCover" id="albumCover" alt="" loading="lazy" onerror="this.classList.add('noImage')" />
  <div class="seriesInfo">
    <span class="heroKicker" id="albumKicker">Album</span>
    <h1 id="albumTitle"></h1>
    <p class="hint hide" id="albumArtist"></p>
    <div class="heroActions">
      <button id="launchBtn" class="heroPlayBtn"><span class="heroPlayIcon" id="launchBtnIcon"></span><span id="launchBtnLabel">Écouter cet album</span></button>
      <a class="linklike" id="embyLink" target="_blank" rel="noopener">Voir sur Emby</a>
    </div>
  </div>
</div>
<input id="searchInput" class="searchBar" type="search" placeholder="Rechercher un morceau..." />
<p class="hint searchEmpty hide">Aucun résultat.</p>
<div id="trackList" class="trackList"></div>
